import { ALL_CARD_RANKS, CARD_RANK_FULL_LABELS } from '../types/cardTypes';
import { assertUnreachable } from './tsUtils';
export function getHandRankProperties(handRank) {
    if (!handRank) {
        return undefined;
    }
    const { handRankOrdinal, kickerChart } = handRank;
    const cardRankChars = kickerChart.map((rankIndex) => ALL_CARD_RANKS[rankIndex]);
    switch (handRankOrdinal) {
        case 0: {
            return undefined;
        }
        case 1: {
            return { name: `${CARD_RANK_FULL_LABELS[cardRankChars[0]]} High` };
        }
        case 2: {
            return { name: `Pair of ${CARD_RANK_FULL_LABELS[cardRankChars[0]]}s` };
        }
        case 3: {
            return {
                name: 'Two Pair',
                subName: `${CARD_RANK_FULL_LABELS[cardRankChars[0]]}s and ${CARD_RANK_FULL_LABELS[cardRankChars[2]]}s`
            };
        }
        case 4: {
            if (cardRankChars[0] === 'J') {
                return { name: 'TRIPLEJACK!' };
            }
            return { name: `Three ${CARD_RANK_FULL_LABELS[cardRankChars[0]]}s` };
        }
        case 5: {
            return { name: 'Straight', subName: `${CARD_RANK_FULL_LABELS[cardRankChars[0]]} High` };
        }
        case 6: {
            return { name: 'Flush', subName: `${CARD_RANK_FULL_LABELS[cardRankChars[0]]} High` };
        }
        case 7: {
            return {
                name: 'Full House',
                subName: `${CARD_RANK_FULL_LABELS[cardRankChars[0]]}s over ${CARD_RANK_FULL_LABELS[cardRankChars[3]]}s`
            };
        }
        case 8: {
            return { name: `Quad ${CARD_RANK_FULL_LABELS[cardRankChars[0]]}s` };
        }
        case 9: {
            if (cardRankChars[0] === 'A') {
                return { name: 'Royal Flush' };
            }
            return { name: 'Straight Flush', subName: `${CARD_RANK_FULL_LABELS[cardRankChars[0]]} High` };
        }
        default: {
            assertUnreachable(handRankOrdinal);
        }
    }
}
